import { render, staticRenderFns } from "./KasBesarPiutangList.vue?vue&type=template&id=04c64294&"
import script from "./KasBesarPiutangList.vue?vue&type=script&lang=js&"
export * from "./KasBesarPiutangList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports